import { render, staticRenderFns } from "./MainInput.vue?vue&type=template&id=90767ed6&scoped=true&"
import script from "./MainInput.vue?vue&type=script&lang=js&"
export * from "./MainInput.vue?vue&type=script&lang=js&"
import style0 from "./MainInput.vue?vue&type=style&index=0&id=90767ed6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90767ed6",
  null
  
)

export default component.exports